import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import classes from './ItemsCounter.module.css'

export default function ItemsCounter({type}) {

    const activeCase = useSelector(state => state.case.activeCase)       

    const [data, setData] = useState(null)

    useEffect(() => {
        if (activeCase) {            

            let arr = activeCase[type]?.filter(item => item.active)   
            if (arr.length > 1) {
                setData(arr)
            } else {
                setData(null)
            }    
        }
    }, [activeCase])


    return <>
        {data && <div className={classes.counter}>{data.length}</div>}
    </>
}